var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ml8 mr8" }, [
    _c(
      "div",
      { staticClass: "flex yxtbiz-rank__horizontal-head" },
      _vm._l(_vm.horizontalHeadImgs, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            style: "width:" + (item.order ? 13 / 41 : 15 / 41) * 100 + "%",
          },
          [
            _c(
              "div",
              {
                staticClass: "yxtbiz-rank__horizontal-head-item",
                class: [
                  "yxtbiz-rank__horizontal-head-item" + item.order,
                  !_vm.contentObj.hasHead && !item.order ? "pt8" : "",
                  item.order && !_vm.rankData[item.order]
                    ? "yxtbiz-rank__horizontal-head-item-hide" +
                      (_vm.contentObj.hasHead ? "-head" : "") +
                      item.order
                    : "",
                ],
                style:
                  "background-image: url(" +
                  _vm.sspImgCdn +
                  (_vm.rankData[item.order] &&
                  _vm.rankData[item.order].rankOrder !== item.order + 1
                    ? _vm.horizontalHeadImgs[
                        _vm.rankData[item.order].rankOrder === 2
                          ? 0
                          : _vm.rankData[item.order].rankOrder
                      ].bg
                    : item.bg) +
                  ");",
              },
              [
                _vm.rankData[item.order]
                  ? _c("div", [
                      _vm.contentObj.hasHead
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "clearfix yxtbiz-rank__horizontal-head-portrait-order-box",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex yxtbiz-rank__horizontal-head-portrait-order",
                                },
                                [
                                  _c("yxtf-image", {
                                    staticClass:
                                      "yxtbiz-rank__horizontal-head-crown",
                                    attrs: {
                                      src:
                                        _vm.sspImgCdn +
                                        (_vm.rankData[item.order].rankOrder !==
                                        item.order + 1
                                          ? _vm.horizontalHeadImgs[
                                              _vm.rankData[item.order]
                                                .rankOrder === 2
                                                ? 0
                                                : _vm.rankData[item.order]
                                                    .rankOrder
                                            ].crown
                                          : item.crown),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-rank__horizontal-head-portrait",
                                      class: [
                                        _vm.disabledSkip(item.order)
                                          ? "cursor-default"
                                          : "cursor-point",
                                        item.order &&
                                        _vm.rankData[item.order].rankOrder !==
                                          item.order + 1
                                          ? "yxtbiz-rank__horizontal-head-portrait-bg" +
                                            _vm.rankData[item.order].rankOrder
                                          : "",
                                      ],
                                      on: {
                                        click: function ($event) {
                                          !_vm.disabledSkip(item.order) &&
                                            _vm.linkToUserIndex(
                                              _vm.rankData[item.order].userId
                                            )
                                        },
                                      },
                                    },
                                    [
                                      _c("yxtf-portrait", {
                                        attrs: {
                                          size: item.order ? "48px" : "80px",
                                          "img-url":
                                            _vm.rankData[item.order].contents[
                                              _vm.dictionaryKeys.userImgUrl
                                            ],
                                          username:
                                            _vm.rankData[item.order].contents[
                                              _vm.dictionaryKeys.userName
                                            ] || "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-rank__horizontal-head-portrait-order-svg",
                                    },
                                    [
                                      _c("yxt-svg", {
                                        attrs: {
                                          width: "24px",
                                          height: "24px",
                                          "remote-url": _vm.sspSvgCdn,
                                          "icon-class":
                                            "rank_no" +
                                            _vm.rankData[item.order].rankOrder,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "yxtbiz-rank__horizontal-head-order",
                              class: [
                                item.order &&
                                _vm.rankData[item.order].rankOrder !==
                                  item.order + 1
                                  ? "yxtbiz-rank__horizontal-head-order-shadow" +
                                    _vm.rankData[item.order].rankOrder
                                  : "",
                              ],
                            },
                            [
                              _c("yxt-svg", {
                                attrs: {
                                  width: "24px",
                                  height: "24px",
                                  "remote-url": _vm.sspSvgCdn,
                                  "icon-class":
                                    "rank_no" +
                                    _vm.rankData[item.order].rankOrder,
                                },
                              }),
                            ],
                            1
                          ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-rank__horizontal-head-content" },
                        [
                          _vm.contentObj.primaryCode
                            ? _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      !_vm.disabledSkip(item.order) &&
                                        _vm.linkToUserIndex(
                                          _vm.rankData[item.order].userId
                                        )
                                    },
                                  },
                                },
                                [
                                  _c("primary-content", {
                                    staticClass:
                                      "yxtf-weight-6 lh24 font-size-16",
                                    class: _vm.disabledSkip(item.order)
                                      ? "cursor-default"
                                      : "cursor-point",
                                    attrs: {
                                      code: _vm.contentObj.primaryCode,
                                      name: _vm.rankData[item.order].contents[
                                        _vm.contentObj.primaryCode
                                      ],
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.contentObj.secondaryCodes &&
                          _vm.contentObj.secondaryCodes.length
                            ? _c("secondary-content", {
                                staticClass: "text-8c",
                                attrs: {
                                  codes: _vm.contentObj.secondaryCodes,
                                  contents: _vm.rankData[item.order].contents,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.contentObj.attributeCode
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "standard-size-16 text-26 mt8 yxtbiz-rank__horizontal-head-content",
                            },
                            [
                              _c(
                                "yxtf-tooltip",
                                {
                                  staticClass: "ellipsis",
                                  attrs: {
                                    placement: "top",
                                    "open-filter": "",
                                    content: _vm.numberUnit(
                                      _vm.rankData[item.order].contents[
                                        _vm.contentObj.attributeCode
                                      ]
                                    ),
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.numberUnit(
                                          _vm.rankData[item.order].contents[
                                            _vm.contentObj.attributeCode
                                          ]
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }